/*
 * Private preview of the star rating design on the live store (snippets/ll-rating-stars.liquid).
 * Open any page with ?ll_stars_preview=1 to switch it on for this device only (saved in this
 * browser), ?ll_stars_preview=0 to switch it off. Without that, nothing happens: customers only
 * ever see stars from real reviews. The sample numbers match the ones shown in the theme editor.
 */
(function () {
  var KEY = 'llStarsPreview';
  var on = false;

  try {
    var param = new URLSearchParams(window.location.search).get('ll_stars_preview');
    if (param === '1') localStorage.setItem(KEY, '1');
    if (param === '0') localStorage.removeItem(KEY);
    on = localStorage.getItem(KEY) === '1';
  } catch (e) {
    on = false;
  }

  if (!on) return;

  function fill(el) {
    if (el.getAttribute('data-ll-filled')) return;
    el.setAttribute('data-ll-filled', '1');

    var seed = parseInt(el.getAttribute('data-ll-stars-preview'), 10) % 1000;
    var rating = [4.8, 4.9, 5.0][seed % 3];
    var count = (seed % 167) + 14;
    var value = rating.toFixed(1).replace('.', ',');
    var html = '';

    if (el.getAttribute('data-show-value') === 'true') {
      html += '<span class="ll-stars__value" aria-hidden="true">' + value + '</span>';
    }
    html +=
      '<span class="ll-stars__icons" aria-hidden="true" style="--ll-stars: ' + (rating * 20) + '%;">' +
      '<span class="ll-stars__base">★★★★★</span><span class="ll-stars__fill">★★★★★</span></span>';
    if (el.getAttribute('data-show-count') !== 'false') {
      html += '<span class="ll-stars__count" aria-hidden="true">(' + count + ')</span>';
    }

    el.innerHTML = html;
    el.hidden = false;
  }

  function run(root) {
    (root || document).querySelectorAll('[data-ll-stars-preview]').forEach(fill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  // Product cards added later (filters, sorting, pagination, recommendations)
  new MutationObserver(function () { run(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
